angular.module("App.video.evals", ["App.video.service", "App.evals.grid"]);
